export default __webpack_public_path__ + "static/authentication-478394c34a2d5f8f425f4a96785993d1.png";